import $ from "jquery";

class Slide {
    constructor({ container, next, prev }) {
        this.selector = container;
        this.containerEl = $(this.selector);
        this.index = 0;
        this.nextIndex = 0;
        this.slides = "";
        this.nextEl = this.containerEl.find(next);
        this.prevEl = this.containerEl.find(prev);
        this.pagination;
        this.initiateSlide();
    }

    initiateSlide() {
        // console.log($slides.index($('.active')))
        this.slides = this.containerEl.find(".slide");
        this.slides.each(function () {
            $(this).css({ display: "none", opacity: 0 });
        });

        this.pagination = this.containerEl.find(".pagination");
        this.pagination.css("display", "flex");

        this.removeActive();
        this.slides.eq(0).addClass("active");
        this.containerEl.find(".pagination__of").text(this.slides.length);

        // Listener
        this.nextEl.on("click", this.next.bind(this));
        this.prevEl.on("click", this.prev.bind(this));
    }

    removeActive() {
        this.slides.each(function () {
            $(this).removeClass("active");
        });
    }

    updateCounter(index) {
        const $currentPage = this.containerEl.find(".pagination__current");
        $currentPage.text(index);
    }

    destroy() {
        this.containerEl.find('.slide').each(function () {
            $(this).css({ display: 'block', opacity: 1 })
        })

        this.pagination.fadeOut()

        return 'slider destroyed'
    }

    next() {
        this.nextIndex++;
        if (this.nextIndex === this.slides.length - 1) {
            this.nextEl.addClass("is-invisible");
        }
        if (this.nextIndex > 0) {
            this.prevEl.removeClass("is-invisible");
        }
        this.removeActive();
        const $active = this.slides.eq(this.nextIndex).addClass("active");
        gsap.from($active, {
            duration: 0.3,
            scale: 0.9,
            opacity: 0,
            ease: Linear.easeInOut,
        });

        this.updateCounter(this.nextIndex + 1);
    }

    prev() {
        this.nextEl.removeClass("is-invisible");
        if (this.nextIndex >= this.slides.length) {
            this.nextIndex = this.slides.length - 1;
        }

        this.nextIndex--;
        if (this.nextIndex <= 0) this.prevEl.addClass("is-invisible");
        this.removeActive();
        const $active = this.slides.eq(this.nextIndex).addClass("active");
        gsap.from($active, {
            duration: 0.3,
            // x: $active.width() * -1,
            scale: 0.9,
            opacity: 0,
            ease: Linear.easeInOut,
        });

        this.updateCounter(this.nextIndex + 1);
    }
}

export default Slide;
